import Image from "next/image"
import { Anchor } from "../app/components/anchor"
import { TRUSTPILOT_REVIEWS_URL, GOOGLE_MAPS_URL } from "../constants/brand"
import StarRating from "./StarRating"
import { useReviewsContext } from "../context/ReviewsContext"

export default function LocalRatingCard() {
  const { blokReviews } = useReviewsContext()
  return (
    <div className={"flex justify-start items-center gap-4"}>
      <section className="sm:w-[180px] md:w-[160px] md:min-h-[75px] p-2 rounded-lg border border-gray-200 bg-white">
        <Image
          className="h-[22px] w-auto"
          src="/icons/trust-pilot.svg"
          alt="trust pilot logo"
          width={100}
          height={20}
        />
        <div>
          <div className="w-full flex flex-row justify-start items-center sm:items-start md:items-center text-sm">
            <span className="text-md md:text-lg font-semibold font-work_sans text-black pr-2">
              <Anchor
                href={TRUSTPILOT_REVIEWS_URL}
                target="_blank"
                rel="noreferrer noopener"
                dofollow
                passHref
                className="text-black"
              >
                {blokReviews?.trustpilotRatings}
              </Anchor>
            </span>
            <StarRating value={5} className="w-20" />
          </div>
          <span className="text-sm">
            <Anchor
              href={TRUSTPILOT_REVIEWS_URL}
              target="_blank"
              rel="noreferrer noopener"
              dofollow
              passHref
            >
              {blokReviews?.trustpilotReviews} reviews
            </Anchor>
          </span>
        </div>
      </section>
      <section className="sm:w-[180px] md:w-[160px] md:min-h-[75px] p-2 rounded-lg border border-gray-200 bg-white">
        <Image
          className="h-[20px] w-auto"
          src="/icons/google.svg"
          alt="google logo"
          width={100}
          height={20}
        />

        <div>
          <div className="w-full flex flex-row justify-start items-center text-sm">
            <span className="text-md md:text-lg font-semibold font-work_sans text-black pr-2">
              <Anchor
                href={GOOGLE_MAPS_URL}
                target="_blank"
                rel="noreferrer noopener"
                dofollow
                passHref
                className="text-black"
              >
                {blokReviews?.googleRatings}
              </Anchor>
            </span>

            <StarRating value={5} className="w-20" />
          </div>
          <span className="text-sm">
            <Anchor
              href={GOOGLE_MAPS_URL}
              target="_blank"
              rel="noreferrer noopener"
              dofollow
              passHref
            >
              {blokReviews?.googleReviews} reviews
            </Anchor>
          </span>
        </div>
      </section>
    </div>
  )
}
